import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Card from '../elements/Card';
import { getLocationsList } from '../../actions/locationActions.js';

@connect((store) => { return { clinics: store.location.filteredList }; })
class Clinics extends Component {
    componentWillMount() {
        this.props.dispatch(getLocationsList('free clinic'));
    }
    
    render() {
        console.log(this.props.clinics);

        let cliniclist = [];

        for (let clinic in this.props.clinics) {
            let title = this.props.clinics[clinic].displayName;
            let price = this.props.clinics[clinic].price;

            if (parseInt(price) === 0) {
                price = 'Free';
            }

            cliniclist.push(<Card key={clinic} history={this.props.history} title={title} price={price} link={clinic} />);
        }

        return (
            <div>
                <h1 className="ec__font__title text-center">Drop-in Clinics</h1>
                <div className="card-container">
                    {cliniclist}
                </div>
            </div>
        )
    }
}

export default Clinics;


// WEBPACK FOOTER //
// ./src/components/screens/Clinics.js